import { useFeatureFlag as useConfigcatFeatureFlag } from "configcat-react"
import { useMemo } from "react"
import { useAuthenticatedUser } from "../components/indentity-provider.component"

export function useFeatureFlag(key: string, defaultValue: any) {
  const user = useAuthenticatedUser()

  const userObject = useMemo(() => {
    return {
      identifier: user.email,
      custom: {
        "user-roles": `/${user.roles.join("/")}/`
      }
    }
  }, [user])

  const { value, loading: configcatLoading } = useConfigcatFeatureFlag(key, defaultValue, userObject)

  return { value, loading: configcatLoading }
}
